import { Config as DriverConfig } from "driver.js";
import { buttonVariants } from "@/components/ui/button";

export const DEFAULT_TOUR_CONFIG = {
  showProgress: true,
  popoverClass: "bg-card text-popover-foreground",
  onPopoverRender: (popover) => {
    popover.title.classList.value = "scroll-m-8 text-lg mb-2";
    popover.description.classList.value = "text-sm";
    popover.progress.className = "text-gray-400 text-xs";
    const buttonClasses = buttonVariants({ size: "sm" }).split(" ");
    popover.nextButton.classList.add(...buttonClasses);
    popover.previousButton.classList.add(...buttonClasses);
    popover.closeButton.classList.add(
      ...buttonVariants({
        variant: "ghost",
        size: "sm",
      }).split(" "),
    );
  },
  nextBtnText: "Next",
  prevBtnText: "Previous",
} satisfies DriverConfig;
